import { Typography } from 'antd';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import 'dayjs/locale/th';

dayjs.extend(buddhistEra);
dayjs.extend(utc);
dayjs.locale('th');

const defaultFormat = 'DD MMM BBBB';

export const xDateNow = dayjs(new Date());

export function useSpXDate() {
  const forceFormat = ({ date, showTime = false, customFormat = '' }) => {
    try {
      if (!date) throw new Error('Invalid Date');

      if (customFormat) {
        return dayjs(date).format(customFormat);
      }

      return dayjs(date).format(showTime ? `${defaultFormat} HH:mm` : defaultFormat);
    } catch (error) {
      return '-';
    }
  };

  return {
    forceFormat,
  };
}

export function SpXDate({ date = '', withTime = false, style = null }) {
  const { forceFormat } = useSpXDate();

  return <Typography.Text style={style}>{forceFormat({ date, showTime: withTime })}</Typography.Text>;
}
